import React, { useState } from "react";

export default RegisterForm = ({ result, backToHome, serial }) => {
  const [customerName, setCustomerName] = useState("");
  const [customerPhone, setCustomerPhone] = useState("");
  const [customerEmail, setCustomerEmail] = useState("");
  const [agent, setAgent] = useState("");
  const [agentAddress, setAgentAddress] = useState("");
  const [agentCode, setAgentCode] = useState("");
  const [btnText, setBtnText] = useState(wck_app.register_button_field);
  const [isDisabled, setIsDisabled] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [regResult, setRegResult] = useState({});

  const handleRegister = (e) => {
    e.preventDefault();
    setBtnText("");
    setIsLoading(true);
    const handleFetch = fetch(wck_app.handle_uri, {
      method: "POST",
      mode: "same-origin",
      credentials: "include",
      cache: "no-cache",
      headers: new Headers({
        Accept: "application/json",
        "Content-type": "application/x-www-form-urlencoded; charset=UTF-8",
      }),
      body: `action=wck_register&serial=${serial}&customer_name=${customerName}&customer_phone=${customerPhone}&customer_email=${customerEmail}&agent=${agent}&agent_address=${agentAddress}&agent_code=${agentCode}`,
    })
      .then((data) => data.json())
      .catch((e) => `رد شد: ${e}`);
    handleFetch.then((res) => {
      setRegResult(res);
      setIsDisabled(true);
      setIsLoading(false);
      setBtnText("عملیات تمام شد!");
    });
  };
  return (
    <div className="warranty-wrapper">
      <div className="nav">
        <svg
          onClick={backToHome}
          className="btn-back"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M14 5l7 7m0 0l-7 7m7-7H3"
          />
        </svg>
        <span className="msg-back">{wck_app.back_button_field}</span>
      </div>
      <div id="msg">
        <p>{result.msg}</p>
        {regResult.status === "ok" && (
          <div className="success">{regResult.msg}</div>
        )}
        {regResult.status === "fail" && (
          <div className="error">{regResult.msg}</div>
        )}
      </div>
      <form method="post" onSubmit={(e) => handleRegister(e)}>
        <label htmlFor="customer_name">{wck_app.name_field}</label>
        <input
          type="text"
          required
          name="customer_name"
          onChange={(e) => setCustomerName(e.target.value)}
          onInvalid={(e) =>
            e.target.setCustomValidity("پر کردن این فیلد ضروری است")
          }
          onInput={(e) => e.target.setCustomValidity("")}
        />

        <label htmlFor="customer_phone">{wck_app.mobile_field}</label>
        <input
          type="text"
          required
          name="customer_phone"
          onChange={(e) => setCustomerPhone(e.target.value)}
          onInvalid={(e) =>
            e.target.setCustomValidity("پر کردن این فیلد ضروری است")
          }
          onInput={(e) => e.target.setCustomValidity("")}
        />

        {wck_app.is_email_active && (
          <>
            <label htmlFor="customer_email">{wck_app.email_field}</label>
            <input
              type="email"
              required
              name="customer_email"
              onChange={(e) => setCustomerEmail(e.target.value)}
              onInvalid={(e) =>
                e.target.setCustomValidity("پر کردن این فیلد ضروری است")
              }
              onInput={(e) => e.target.setCustomValidity("")}
            />
          </>
        )}

        {wck_app.is_agent_active && (
          <>
            <label htmlFor="agent">{wck_app.agent_field}</label>
            <input
              type="text"
              required
              name="agent"
              onChange={(e) => setAgent(e.target.value)}
              onInvalid={(e) =>
                e.target.setCustomValidity("پر کردن این فیلد ضروری است")
              }
              onInput={(e) => e.target.setCustomValidity("")}
            />
            <label htmlFor="agent_address">{wck_app.agent_address_field}</label>
            <input
              type="text"
              required
              name="agent_address"
              onChange={(e) => setAgentAddress(e.target.value)}
              onInvalid={(e) =>
                e.target.setCustomValidity("پر کردن این فیلد ضروری است")
              }
              onInput={(e) => e.target.setCustomValidity("")}
            />
            <label htmlFor="agent_code">{wck_app.agent_code_field}</label>
            <input
              type="text"
              required
              name="agent_code"
              onChange={(e) => setAgentCode(e.target.value)}
              onInvalid={(e) =>
                e.target.setCustomValidity("پر کردن این فیلد ضروری است")
              }
              onInput={(e) => e.target.setCustomValidity("")}
            />
          </>
        )}
        <button
          type="submit"
          id="register_btn"
          className="btn btn-green"
          disabled={isDisabled}
        >
          {btnText}
          {isLoading && (
            <svg
              id="registering"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
            >
              <circle
                className="opacity-25"
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                strokeWidth="4"
              ></circle>
              <path
                className="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
              ></path>
            </svg>
          )}
        </button>
      </form>
    </div>
  );
};
